import { axios } from "@Root/API";

export const postAdminRole = payload => {
  return axios.post("roles", payload);
};
